<template>
  <cookie-law theme="ci">
    <div class="Cookie__inner" slot-scope="props">
      <p class="Cookie__content" v-html="$t('generic.cookieLayer.copy')"></p>
      <CiButton class="button button--primary" @click="props.accept">
        {{ $t('generic.cookieLayer.acceptButton') }}
      </CiButton>
    </div>
  </cookie-law>
</template>

<script>
import CookieLaw from 'vue-cookie-law'

import { CiButton } from '@/components'

export default {
  name: 'CiCookieLayer',
  components: {
    CookieLaw,
    CiButton,
  },
}
</script>

<style lang="scss" scoped>
.Cookie--ci {
  background: $primary-orange;
  padding: 1.5rem;

  .Cookie__inner {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;

    @include media-breakpoint-up(md) {
      flex-direction: row;
    }
  }

  .Cookie__content {
    @include media-breakpoint-up(md) {
      padding-right: 1.5rem;
    }
  }
}
</style>
